module.exports = __webpack_public_path__ + "static/media/MOTUS_COLOR_LOGO.916a929d.png";